
const actions = {
  GET_POSTS: "GET_POSTS",
  GET_POSTS_RESULT: "GET_POSTS_RESULT",
  GET_POSTS_ERROR: "GET_POSTS_ERROR",

  getAllPosts: () => ({
    type: actions.GET_POSTS,
  }),
 };

export default actions;
